import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import {withRouter} from "react-router-dom";
import {setSmallBoneSkeleton} from "../../skeleton";

class BlogSidebar extends Component {
    applySearch = (e) => {
        this.props.handleSearch(e.target.value);
    };
    preventKeyPress = (e) => {
        if (e.keyCode === 13 || e.keyCode === 10) {
            e.preventDefault();
        }
    }

    render() {
        const {categories, tags, loading, slug} = this.props;
        const categoriesList = categories && categories.length ? categories.map((category, index) => {
            return (
                <a href={"/blog/category/" + category.slug}
                   className={slug && category.slug === slug ? "active shadow-4d" : "shadow-4d"}
                   key={index}>
                    <li className="cat-item cat-item-36 caliteck-color">{category.name} ({category.posts})
                    </li>
                </a>
            )
        }) : null;
        const tagList = tags && tags.length ? tags.map((tag, tagIndex) => {
            return (
                <a href={"/blog/tag/" + tag.slug}
                   className={slug && tag.slug === slug ? "active tag-cloud-link" : "tag-cloud-link"} key={tagIndex}>
                    {tag.name}
                </a>
            )
        }) : null;
        return (
            <div className="col-md-4 sidebar ftco-animate">
                <div className="sidebar-box" hidden={this.props.match.path !== "/blog"}>
                    <form action="#" className="search-form shadow-4d">
                        <div className="form-group ">
                            <input type="text" className="form-control "
                                   onKeyDown={(e) => this.preventKeyPress(e)}
                                   placeholder="Search" onChange={(e) => this.applySearch(e)}/>
                        </div>
                    </form>
                </div>
                <div className="sidebar-box ftco-animate">
                    <div className="categories">
                        <h3>{this.props.translate("categories")}</h3>
                        {loading === false ? categoriesList : setSmallBoneSkeleton(4)}
                    </div>
                </div>
                <div className="sidebar-box ftco-animate">
                    <h3>{this.props.translate("tag_cloud")}</h3>
                    <div className="tagcloud">
                        {loading === false ? tagList : setSmallBoneSkeleton(4)}
                    </div>
                </div>


            </div>
        )
    }
}


export default withRouter(withTranslate(BlogSidebar));